export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-2/5">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-accent-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20shopper%20browsing%20fashion%20on%20laptop%20in%20a%20bright%20minimal%20room%2C%20warm%20natural%20sunlight%20from%20large%20window%2C%20cream%20and%20neutral%20interior%2C%20casual%20stylish%20attire%2C%20genuine%20relaxed%20expression%2C%20lifestyle%20editorial%20photography%2C%20clean%20aesthetic%2C%20soft%20shadows&width=600&height=750&seq=trust-new-section-2026&orientation=portrait"
                alt="Why shoppers trust our Sugargoo Spreadsheet guides"
                title="Sugargoo Spreadsheet Trust - E-E-A-T Shopping Resource"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <span className="text-xs font-semibold tracking-wider text-foreground-500 uppercase">
              (E-E-A-T)
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2 mb-8">
              Why Shoppers Trust{' '}
              <span className="text-foreground-400">Our Spreadsheet</span>
            </h2>
            <div className="space-y-5 mb-8">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <div>
                  <h4 className="font-semibold text-foreground-950 text-sm">Updated Regularly</h4>
                  <p className="text-xs text-foreground-600 mt-1">
                    Our spreadsheets are refreshed with current product links so you always get the latest inventory
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <div>
                  <h4 className="font-semibold text-foreground-950 text-sm">Curated Product Lists</h4>
                  <p className="text-xs text-foreground-600 mt-1">
                    Each category is hand-picked and verified for quality, relevance, and availability
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <div>
                  <h4 className="font-semibold text-foreground-950 text-sm">Beginner-Friendly Guides</h4>
                  <p className="text-xs text-foreground-600 mt-1">
                    Step-by-step tutorials written in plain English so anyone can start shopping with confidence
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <div>
                  <h4 className="font-semibold text-foreground-950 text-sm">Transparent Information</h4>
                  <p className="text-xs text-foreground-600 mt-1">
                    No hidden fees or misleading claims. We provide honest, straightforward product information
                  </p>
                </div>
              </div>
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
              Important Safety Information
            </h3>
            <div className="bg-background-100 rounded-xl p-5">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-2.5 font-semibold text-foreground-950">Risk</th>
                    <th className="text-left py-2.5 font-semibold text-foreground-950">Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="py-2 text-foreground-700">Customs</td>
                    <td className="py-2 text-foreground-600">May vary by country</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="py-2 text-foreground-700">Quality</td>
                    <td className="py-2 text-foreground-600">Depends on seller</td>
                  </tr>
                  <tr>
                    <td className="py-2 text-foreground-700">Shipping</td>
                    <td className="py-2 text-foreground-600">May be delayed</td>
                  </tr>
                </tbody>
              </table>
              <p className="text-xs text-foreground-500 mt-4 leading-relaxed">
                <strong>Disclaimer:</strong> We do not sell products. We are not responsible for
                purchases made through linked pages. Users should verify items before buying.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}